const getters = {
  token: (state) => state.user.token,
  menus: (state) => state.user.menus,
  isCollapse: (state) => state.isCollapse,
  userId: (state) => state.user.userInfo.id,
  userName: (state) => state.user.userInfo.name,
  userRole: (state) => state.user.userInfo.role,
  isGetPermission: (state) => state.user.userInfo.isGetPermission,
  tabs: (state) => state.user.tabs,
}

export default getters
